const WORDS = ["Driver airbags", "Passenger airbags", "Knee airbags", "Curtain airbags", "Seat airbags", "Airbag kits", "Seat belts", "SRS modules"];

export const Marquee = () => (
  <section data-testid="editorial-marquee" className="marquee-wrap overflow-hidden border-y border-white/10 bg-[#0B1016] py-8">
    <div className="marquee-track flex w-max">
      {[0, 1].map((k) => (
        <div key={k} className="flex shrink-0 items-center" aria-hidden={k === 1}>
          {WORDS.map((w, i) => (
            <span key={w} className="flex items-center">
              <span className={`font-display text-5xl font-black uppercase tracking-tight sm:text-7xl ${i % 2 ? "text-outline" : "text-white"}`}>
                {w}
              </span>
              <span className="mx-8 inline-block h-3 w-3 rotate-45 bg-[#E11D48]" />
            </span>
          ))}
        </div>
      ))}
    </div>
  </section>
);
